import Vue from 'vue';
import Vuex from 'vuex';
import common, { CommonStore } from "@/common/store/modules/CommonStore";
import auth, { AuthState } from './modules/auth';
import dashboard, { DashboardStore } from "@/common/store/modules/DashboardStore";
import message, { MessageStore } from "@/common/store/modules/MessageStore";
import depots, { DepotsStore } from "@/common/store/modules/DepotsStore";
import depot, { DepotStore } from "@/common/store/modules/DepotStore";

Vue.use(Vuex);

export type RootStore = {
  common: CommonStore,
  message: MessageStore,
  auth: AuthState,
  dashboard: DashboardStore,
  depots: DepotsStore,
  depot: DepotStore
}

export default new Vuex.Store<RootStore>({
  modules: {
    common,
    message,
    auth,
    dashboard,
    depots,
    depot
  }
});
